<template>
    <div>
        <rkm-row class="mb-2">
            <rkm-col cols="12" v-if="data.form.historico">

                <rkm-button
                    v-if="data.form.historico.length > 0"
                    @click="selecionarTodos()"
                    color="primary"
                >
                    <template v-if="handleDisabledAtribuidos">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    v-if="!handleDisabledAtribuidos"
                    @click="print()"
                    color="primary"
                >
                    Imprimir atendimento(s) selecionado(s)
                </rkm-button>

                <rkm-button
                    v-if="!hideHistoricoV1"
                    @click="getUrlHistoricoConectaSUSV1"
                    color="primary"
                >
                    Histórico - ConectaSUS V1
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-list
            :items="data.form.historico"
            @collapse-show="load"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col class="flex-grow-0">
                        <rkm-row @click.stop>
                            <rkm-col>
                                <rkm-form-checkbox
                                    :disabled="item.comSigilo"
                                    v-model="item.selecionado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-row v-if="item.origem === 'ambulatorio'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.dataHora"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => getAmbulatorioTipoLabel(item)"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.codigo} - ${ item.lotacao.ocupacao.nome}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.tipoAtendimento}`"
                                    label="Consulta"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.centroCusto.unidade.nomeFantasia}`"
                                    label="Unidade de atendimento"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="!item.comSigilo"
                                cols="auto"
                            >

                                <rkm-button
                                    :disabled="!item.isAtendimentoSoapAssinado"
                                    color="info"
                                    title="Imprimir (assinados)"
                                    @click="openModalImpressao($event, item, true)"
                                    small
                                >
                                    <rkm-icon icon="signature" />
                                </rkm-button>

                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="openModalImpressao($event, item, false)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-else-if="item.origem === 'atencao-basica-visita-domiciliar'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.data"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => 'Atenção básica - Visita domiciliar'"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.usuarioNome} - ${item.ocupacaoDescricao}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="printVisitaDomiciliar($event, item)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-else-if="item.origem === 'pronto-atendimento'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.dataHora"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => 'Pronto atendimento'"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.codigo} - ${item.lotacao.ocupacao.nome}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.tipoAtendimento}`"
                                    label="Consulta"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.centroCusto.unidade.nomeFantasia}`"
                                    label="Unidade de atendimento"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="printFaaEletronica($event, item)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row
                    v-if="'dados' in item"
                    class="p-2"
                >
                    <rkm-col cols="12">
                        <template v-if="item.origem === 'ambulatorio'">
                            <BoxPreAtendimento
                                v-if="item.tipo === 'pre-atendimento'"
                                :item="item.dados"
                            />

                            <BoxAtendimento
                                v-if="item.tipo === 'atendimento'"
                                :item="item.dados"
                            />

                            <BoxPosConsulta
                                v-if="item.tipo === 'pos-consulta'"
                                :item="item.dados"
                            />
                        </template>

                        <BoxAtencaoBasicaVisitaDomiciliar
                            v-if="item.origem === 'atencao-basica-visita-domiciliar'"
                            :item="item.dados"
                        />

                        <BoxProntoAtendimento
                            v-if="item.origem === 'pronto-atendimento'"
                            :item="item.dados"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <ModalImpressao
            ref="ModalImpressao"
            :printSigned="printSigned"
            :assinaturaEletronica="printSigned"
        />
    </div>
</template>

<script>
// Components.
import BoxAtencaoBasicaVisitaDomiciliar from './components/atencao-basica/visita-domiciliar/Index'
import BoxAtendimento from './components/atendimento/Index'
import BoxPreAtendimento from './components/pre-atendimento/Index'
import BoxPosConsulta from './components/pos-consulta/Index'
import BoxProntoAtendimento from './components/pronto-atendimento/Index'
import Item from './components/item/Index'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import {error, file, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAtencaoBasicaVisitaDomiciliar,
        BoxAtendimento,
        BoxPreAtendimento,
        BoxPosConsulta,
        BoxProntoAtendimento,
        Item,
        ModalImpressao
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
            prontoAtendimentoPdf: this.getConectaSusRepository('impressao.prontoAtendimento'),
            atencaoBasicaPdf: this.getConectaSusRepository('impressao.atencaoBasica'),
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar'),
        }
    },
    props: {
        data: {type: Object, required: true},
        hideHistoricoV1: {type: Boolean, default: false}
    },
    computed: {
        handleDisabledAtribuidos() {

            const atribuidos = this.data.form.historico.filter(item => item.selecionado)

            return atribuidos.length === 0 ? true : false
        },
    },
    data: ()  => ({
        printSigned: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load(item) {

            if (!('dados' in item)) {

                let repository = null

                if (item.origem === 'ambulatorio') {

                    if (item.comSigilo) return

                    repository = item.tipo === 'atendimento'
                        ? this.repositories.atendimento.getHistoricoAtendimentoSoap
                        : (item.tipo === 'pos-consulta'
                            ? this.repositories.atendimento.getHistoricoPosConsulta
                            : this.repositories.atendimento.getHistoricoPreAtendimento
                        )
                }
                else if (item.origem === 'atencao-basica-visita-domiciliar') {

                    repository = this.repositories.visitaDomiciliar.getVisitaDomiciliarForHistorico
                }
                else if (item.origem === 'pronto-atendimento') {

                    repository = this.repositories.atendimento.getHistoricoProntoAtendimentoAtendimento
                }

                this.setLoading()

                repository(item.id)
                    .then(({data}) =>  this.$set(item, 'dados', data))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                    
            }
        },
        getUrlHistoricoConectaSUSV1() {
            this.setLoading()

            this.repositories.atendimento.getUrlHistoricoConectaSUSV1(this.data.form.paciente.prontuario)
                .then(response => window.open(response.data.url, '_blank'))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAmbulatorioTipoLabel(item) {

            if (item.tipo === 'atendimento') {

                return item.isAtendimentoEnfermagem ? 'Atendimento de enfermagem': 'Atendimento'
            }
            else if (item.tipo === 'pos-consulta') {

                return 'Pós-consulta'
            }

            return 'Pré-atendimento'
        },
        openModalImpressao(event, item, assinado) {

            event.stopPropagation();

            const id = assinado ? item.id : item.atendimentoId

            this.printSigned = !!assinado;

            let tipoAtend =  item.tipo;

            this.$nextTick(() => {
                this.$refs.ModalImpressao.open(tipoAtend, id);
            });
        },
        printFaaEletronica(event, item) {

            event.stopPropagation();

            this.setLoading()

            this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printVisitaDomiciliar(event, item) {

            event.stopPropagation();

            this.setLoading()

            this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {

            this.data.form.historico
                .filter(item => item.selecionado)
                .map(item => {

                    this.setLoading()

                    let request = null;

                    if (item.origem === 'ambulatorio') {

                        request = item.tipo === 'atendimento'
                            ? this.repositories.pdf.atendimento(item.atendimentoId)
                            : (item.tipo === 'pos-consulta'
                                ? this.repositories.pdf.posConsulta(item.atendimentoId)
                                : this.repositories.pdf.preAtendimento(item.atendimentoId)
                            )
                    }
                    else if (item.origem === 'pronto-atendimento') {

                        request = this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                    }
                    else if (item.origem === 'atencao-basica-visita-domiciliar') {

                        request = this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                    }

                    request
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        selecionarTodos(){

            if(this.handleDisabledAtribuidos){

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = true))
            } else {

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = false))
            }
        },
    },
    mixins: [error, file, repository]
}
</script>